import type { PropsWithChildren, FunctionComponent } from 'react'
import { EmptyViewReload } from '../../../../dash-components/empty-view-reload/EmptyViewReload'

export const StoreGroupsLoadError: FunctionComponent<PropsWithChildren<unknown>> = () => (
  <EmptyViewReload
    titleId="settings.storeGroups.error.title"
    bodyId="settings.storeGroups.error.body"
  />
)
